import { useMutation } from 'react-query';
import { useError } from '../../../common/Errors/ErrorContext/ErrorContext';
import { acceptUnlockMediaPlan } from '../../../../../../api/services/mediaPlanning/acceptUnlockMediaPlan';

type Variables = {
  action: 'accept' | 'revert';
  id: string | null;
};

const useAcceptUnlockMediaPlan = () => {
  const { showError } = useError();

  const mutation = useMutation(
    async ({ id, action }: Variables) => {
      return acceptUnlockMediaPlan(id, action);
    },
    {
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.message || error?.message || 'Unknown error';
        showError(errorMessage);
      },
    }
  );

  return {
    acceptUnlockMediaPlanTrigger: mutation.mutate,
    asyncAcceptUnlockMediaPlanTrigger: mutation.mutateAsync,
    data: mutation.data,
    isLoading: mutation.isLoading,
    isError: mutation.isError,
  };
};

export default useAcceptUnlockMediaPlan;
